module.exports = __webpack_public_path__ + "img/ennetix-setting-page-system-configuration.581d7314.png";